import React from "react";

const NearbyEmptyIllustration = () => (
  <svg
    className="nearby-empty__illustration"
    viewBox="0 0 200 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect x="20" y="24" width="160" height="96" rx="16" fill="#F4F7FB" stroke="#E5E7EB" />
    <path
      d="M20 52H180"
      stroke="#E5E7EB"
      strokeWidth="1.5"
      strokeDasharray="4 6"
    />
    <circle cx="100" cy="78" r="28" fill="#E8F5EE" />
    <circle cx="100" cy="78" r="8" fill="#16A34A" />
    <path
      d="M100 62V78L110 86"
      stroke="#15803D"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="44" y="44" width="28" height="28" rx="8" fill="#FEE2E2" />
    <path
      d="M58 52V64M52 58H64"
      stroke="#C73732"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M132 40L148 56L132 72"
      stroke="#2563EB"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="148" cy="56" r="4" fill="#2563EB" />
    <path
      d="M72 96C84 88 116 88 128 96"
      stroke="#CBD5E1"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default NearbyEmptyIllustration;
